import React from 'react';
import { Field } from 'redux-form/immutable';
import * as PropTypes from 'prop-types';
import { isRequiredFn } from '../../modules/Taps/components/NDFL3/services/CommonValidations';
import { validateDateAndTime } from '../../utils/reduxForm/validations';
import { isArray } from 'lodash';
import DateTimeField from './DateTimeField';

const DateTimeFieldWrapper = (WrappedComponent) => {
  const Component = (props) => {
    const { validate, ...overProps } = props;
    const fillValidations = () => {
      const { isRequired } = props;
      let validations = [];
      const addedValidation = (val) => {
        validations.push(val);
      };
      addedValidation(validateDateAndTime);
      if (isRequired) {
        addedValidation(isRequiredFn);
      }
      return validations;
    };

    const initialValidations = fillValidations();
    const allValidations = validate
      ? isArray(validate)
        ? [...initialValidations, ...validate]
        : [...initialValidations, ...[validate]]
      : initialValidations;
    return <WrappedComponent {...overProps} validate={allValidations} />;
  };

  Component.displayName = 'DateTimeFieldWrapperComponent';
  Component.propTypes = {
    isRequired: PropTypes.bool,
    validate: PropTypes.bool,
  };

  return Component;
};
const DateTimeFieldValidate = DateTimeFieldWrapper(Field);
DateTimeFieldValidate.defaultProps = {
  component: DateTimeField,
};

export default DateTimeFieldValidate;
